import { render, staticRenderFns } from "./IconSvgLocation.vue?vue&type=template&id=0ae24e35&scoped=true&"
import script from "./IconSvgLocation.vue?vue&type=script&lang=js&"
export * from "./IconSvgLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae24e35",
  null
  
)

export default component.exports